import React, { useState } from 'react';
import './LengthConverter.css';

const LengthConverter = () => {
  const [inputValue, setInputValue] = useState('');
  const [selectedUnit, setSelectedUnit] = useState('meters');
  const [convertedValue, setConvertedValue] = useState('');

  const units = ['meters', 'feet'];

  const convertLength = () => {
    const inputValueFloat = parseFloat(inputValue);

    if (isNaN(inputValueFloat)) {
      setConvertedValue('Please enter a valid number.');
      return;
    }

    if (selectedUnit === 'meters') {
      const feetValue = inputValueFloat * 3.28084;
      setConvertedValue(`${inputValue} meters is approximately ${feetValue.toFixed(2)} feet.`);
    } else {
      const metersValue = inputValueFloat / 3.28084;
      setConvertedValue(`${inputValue} feet is approximately ${metersValue.toFixed(2)} meters.`);
    }
  };

  return (
    <div className="tool-page-container">
      <div className="tool-page-content">
        <h1>Length Converter</h1>
        <p className="tool-description">
          Convert length measurements between meters and feet.
        </p>

        <div className="tool-section">
          <label className="tool-label">Enter Length:</label>
          <div className="input-group">
            <input
              className="length-input"
              type="number"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              placeholder="Enter length value"
            />
            <select
              className="unit-select"
              value={selectedUnit}
              onChange={(e) => setSelectedUnit(e.target.value)}
            >
              {units.map((unit) => (
                <option key={unit} value={unit}>
                  {unit}
                </option>
              ))}
            </select>
          </div>
        </div>

        <button className="convert-button" onClick={convertLength}>
          Convert
        </button>

        {convertedValue && (
          <div className="result-section">
            <h2>Result</h2>
            <div className="conversion-result">
              {convertedValue}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LengthConverter;
